const error = require('./error');
const success = require('./success');
const { errors } = require('@transfeeradev/api-enums');
const { maxValue: billetMaxValue } = require('@transfeeradev/api-enums/billet');
const { ErrorMessageCompiler, MoneyService } = require('@transfeeradev/api-services');
const Barcode = require('./Barcode');
const DueDate = require('./DueDate');

const MAX_VALUE = billetMaxValue.MAX_VALUE;

class Value {
  constructor(
    billet,
    options = {
      disallowOverdue: false,
      allowCustomValue: false
    }
  ) {
    this._billet = { ...billet };
    this._options = { ...options };

    if (!this._billet.barcode && !this._billet.value) {
      throw new Error('barcode or value is required');
    }
  }

  validate() {
    let barcodeData = {};

    if (this._billet.barcode) {
      barcodeData = new Barcode(this._billet).getData();
    }

    const dataValidation = this._dataValidation(barcodeData);

    if (!dataValidation.isValid) {
      return dataValidation;
    }

    if (this._billet.value > MAX_VALUE) {
      const errorMessage = new ErrorMessageCompiler(errors.ptBr.bil.MAX_VALUE, {
        maxValue: MoneyService.formatToBR(MAX_VALUE, false)
      }).compile();

      return error(errorMessage, 'value');
    }

    const isOverdue = new DueDate(this._billet).isOverdue();
    const allowCustomValue = this._options.allowCustomValue || (isOverdue && !this._options.disallowOverdue);

    if (+barcodeData.value && +barcodeData.value !== +this._billet.value && !allowCustomValue) {
      return error(errors.ptBr.bil.INVALID_VALUE, 'value');
    }

    if (!+barcodeData.value && !+this._billet.value) {
      return error(errors.ptBr.bil.MIN_VALUE, 'value');
    }

    return success;
  }

  _dataValidation(barcodeData) {
    this._billet.value = !this._billet.value ? barcodeData.value : this._billet.value;

    if (isNaN(+this._billet.value) || +this._billet.value < 0) {
      return error(errors.ptBr.bil.INVALID_VALUE, 'value');
    }

    return success;
  }
}

module.exports = Value;
